import { render } from "./sales-report.vue?vue&type=template&id=083fb977"
import script from "./sales-report.vue?vue&type=script&lang=js"
export * from "./sales-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__